import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import MocktailGenerator from './components/MocktailGenerator';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [userEmail, setUserEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasCheckedCookie, setHasCheckedCookie] = useState(false);

  useEffect(() => {
    // Check for existing email cookie
    const savedEmail = Cookies.get('rysl_user_email');
    if (savedEmail) {
      setUserEmail(savedEmail);
    }
    setHasCheckedCookie(true);
    setIsLoading(false);
    
    // Set up global email capture handler
    window.handleEmailCapture = (email) => {
      handleEmailSubmit(email);
    };
    
    return () => {
      delete window.handleEmailCapture;
    };
  }, []);

  const handleEmailSubmit = (email) => {
    // Save email to cookie (expires in 30 days)
    Cookies.set('rysl_user_email', email, { expires: 30 });
    setUserEmail(email);
  };

  if (isLoading) {
    return (
      <div className="App loading">
        <div className="spinner"></div>
      </div>
    );
  }

  // Don't render anything until we've checked the cookie
  if (!hasCheckedCookie) {
    return (
      <div className="App loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <MocktailGenerator userEmail={userEmail} />
	  <Footer />
    </div>
  );
}

export default App;
